import React from 'react';
import CheckIinInQueue from './CheckIinInQueue';
import ChildInformationButton from './СhildInformationButton';

function CheckIinInQueueButton({ code, value, setDisabled, metadataKey }) {
  return (
    <>
      <ChildInformationButton code={code} value={value} metadataKey={metadataKey} />
      <CheckIinInQueue code={code} value={value} setDisabled={setDisabled} />
    </>
  );
}

export default CheckIinInQueueButton;
